module.exports = __webpack_public_path__ + "img/HappyIndianCouple.56846ffd.jpeg";